import React from 'react';
import PropTypes from 'prop-types';
import RpTable from 'rp-react-table';
import Filter from 'rp-react-common/Filter';

import FilteringComponent from '../../shared/filter';
import columns from './columns';
import categoriesFactory from './categories';
import categoriesReducer from './categoriesReducer';
import { getCategories } from '../../utils/storage';

class Horses extends FilteringComponent {
    constructor(props) {
        super(props);
        const {
            data: { horses, seasonInfo: profileSeasonInfo },
            params: { type },
        } = this.props;
        const { seasonInfo, horses: horsesData } = horses || {};
        // seasonInfo data absent in horses request data when jockey hasn't current year races
        // but it's available in profile overview request
        const { countryCode, raceType } = seasonInfo || profileSeasonInfo || {};

        const categories = categoriesFactory(countryCode, raceType);

        this.state = {
            data: horsesData || [],
            loading: false,
            categories,
            fetchError: false,
        };

        const columnsSet = type === 'trainer' ? 'trainer' : 'default';
        this.columns = columns[columnsSet];
        this.dataKey = 'horses';
    }

    componentDidMount() {
        const { params: { tab, type } } = this.props;
        const categories = getCategories(tab, type, categoriesReducer, this.state.categories);
        if (categories) {
            this.onFilterApply(categories);
        }
    }

    buildUrl = ({ timePeriod, raceType }) => {
        const { type, id } = this.props.params;
        return `filter/${type}/${id}/horses/${timePeriod.split('/')[0]}/${raceType}`;
    };

    render() {
        const { data, loading, categories, fetchError } = this.state;

        return (
            <section className="mp-horses">
                {categories && <Filter
                    categories={categories}
                    categoriesReducer={categoriesReducer}
                    columns={this.columns}
                    fetchError={fetchError}
                    onFilterApply={this.onFilterApply}
                />}
                {!fetchError && (
                    <RpTable
                        data={data}
                        columns={this.columns}
                        loading={loading}
                        noDataText="No horses found"
                        resultsPerPage={50}
                    />
                )}
            </section>
        );
    }
}

Horses.defaultProps = {
    data: {
        horses: {
            seasonInfo: {},
        },
    },
};

Horses.propTypes = {
    data: PropTypes.shape({
        horses: PropTypes.object,
    }).isRequired,
    params: PropTypes.shape({
        type: PropTypes.string,
        id: PropTypes.string,
    }).isRequired,
};

export default Horses;



// WEBPACK FOOTER //
// ./src/js/human/horses/Horses.jsx